import React, { useState } from 'react';
import './tradingaccount.css'
import AccountType from './AccountType';
import PlatformMarkets from './PlatformMarkets';

const TradingAccount = () => {
    const [activeCard, setActiveCard] = React.useState(0)
    const handleClick = (index) => {
        setActiveCard(index)
    }
    
    return (
        <div className="trading-account-container">
            <AccountType />
            <div className='trading-section-2'>
                <div className='trading-section2-child-1'>
                <p className='section-highlight'>Account</p>
                <h1 className='section-heading'>About RiseFX </h1>
                <p className='section-aboutpara'>Trade with a trusted international broker and explore hundreds of trading assets, including stocks, commodities, and indices.</p>
                <div className='inner-child' onClick={() => setActiveCard(0)}>
                    <h2>Who we are</h2>
                    {activeCard === 0 && (
                        <p>We are a team of experienced traders and technologists who are passionate about making trading accessible to everyone.</p>
                    )}
                </div>
                <div className='inner-child' onClick={() => setActiveCard(1)}>
                    <h2>What we do</h2>
                    {activeCard === 1 && (
                        <p>We provide cutting-edge trading technology and personalized financial services to enhance your trading experience.</p>
                    )}
                </div>
                <div className='inner-child' onClick={() => setActiveCard(2)}>
                    <h2>How it works</h2>
                    {activeCard === 2 && (
                        <p>Our platform leverages technology to streamline trading operations and offers intuitive tools for traders.</p>
                    )}
                </div>
                </div>
                <div className='trading-section2-child-2'>
                    <img src='/images/section-trade.jpg' alt='error'/>
                </div>
            </div>
            <div className='trading-section-3'>
                <div className='section-3-cards'>
                <div className='trading-section3-child-1 section-3-first-card'>
                    <div className='inner-card-heading'>
                        <h1 className='num-heading'>150+</h1>
                        <h4 className='text-heading'>Countries</h4>
                        <p>A trusted platform connecting traders across the globe for smarter trading choices.                        </p>
                    </div>
                </div>
                <div className='trading-section3-child-1'>
                    <div className='inner-card-heading'>
                        <h1 className='num-heading'>4000+</h1>
                        <h4 className='text-heading'>Intellectual Brokers</h4>
                        <p>A trusted network empowering investors with intelligent opportunities.</p>
                    </div>
                </div>
                <div className='trading-section3-child-1 section-3-third-card'>
                    <div className='inner-card-heading'>
                        <h1 className='num-heading'>90+</h1>
                        <h4 className='text-heading'>Awards</h4>
                        <p>Recognized globally for excellence and innovation in trading.</p>
                    </div>
                </div>
                </div>
            </div>
            <PlatformMarkets />
        </div>
    )
}

export default TradingAccount;
